export const testimonialsData = [
  {
    id: 1,
    quote: "When our family was in total crisis, UMED provided not just psychiatric stabilization, but genuine human dignity. The doctors explained every step with empathy and kept us involved throughout my brother's recovery.",
    author: "Family Member of a Former Patient",
    location: "Pune, Maharashtra",
    relation: "Sister of Inpatient Resident",
    careCategory: "Deaddiction & Psychiatric Rehabilitation"
  },
  {
    id: 2,
    quote: "The serene environment and structured daily activities made a profound difference. My daughter was treated with immense respect by the nursing team and psychologists. She has regained her confidence and daily rhythm.",
    author: "Family Member of a Former Patient",
    location: "Mumbai, Maharashtra",
    relation: "Mother of Resident",
    careCategory: "Mood Disorder & Psychological Care"
  },
  {
    id: 3,
    quote: "The psychiatric rehabilitation program taught me how to manage my condition and live independently again. The occupational therapy and regular counseling gave me back my sense of self-worth and purpose.",
    author: "Former Resident",
    location: "Kolhapur, Maharashtra",
    relation: "Recovered Patient (Alumni)",
    careCategory: "Psychiatric Rehabilitation & Aftercare"
  },
  {
    id: 4,
    quote: "The multi-disciplinary medical care and 24/7 psychiatric supervision gave us peace of mind during a critical time. The holistic approach, including yoga, counseling, and family therapy sessions, helped rebuild our family trust.",
    author: "Family Member of a Former Patient",
    location: "Sangli, Maharashtra",
    relation: "Father of Inpatient Resident",
    careCategory: "Deaddiction & Family Counseling"
  },
  {
    id: 5,
    quote: "After months of struggling with severe depression and anxiety, finding UMED was a turning point. The compassionate clinical staff and structured routine helped me rediscover hope and emotional balance.",
    author: "Former Resident",
    location: "Satara, Maharashtra",
    relation: "Recovered Patient (Alumni)",
    careCategory: "Comprehensive Mental Healthcare"
  },
  {
    id: 6,
    quote: "UMED's post-discharge follow-up care and relapse prevention guidance have been invaluable. The seamless transition from residential care back into society made all the difference for my husband's long-term wellness.",
    author: "Family Member of a Former Patient",
    location: "Belagavi, Karnataka",
    relation: "Wife of Inpatient Resident",
    careCategory: "Relapse Prevention & Aftercare"
  }
];

